import { render, staticRenderFns } from "./HlaAntibodiesComments.vue?vue&type=template&id=7a2b28fe&"
import script from "./HlaAntibodiesComments.vue?vue&type=script&lang=ts&"
export * from "./HlaAntibodiesComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports